import htmx from 'htmx.org';

// https://htmx.org/docs/#webpack
window.htmx = htmx;
